<template>
  <div class="room_buy">
    <yd-preview :buttons="[]">
      <yd-preview-header>
        <div slot="left">{{book.good_name}}</div>
        <div slot="right"><span @click="bookDel(book.id)">删除</span></div>
      </yd-preview-header>
      <yd-preview-item>
        <div slot="left">入离日期：</div>
        <div slot="right">{{book.ruzhutime}} 至 {{book.likatime}} , 共 {{book.day}} 晚</div>
      </yd-preview-item>
      <yd-preview-item>
        <div slot="left">每间最大入住人数：</div>
        <div slot="right">{{book.max}}</div>
      </yd-preview-item>
      <yd-preview-item class="add_mount">
        <div slot="left">
          <yd-spinner v-model="book.num" :callback="updateBook"></yd-spinner>
        </div>
        <div slot="right">￥ {{book.price}}</div>
      </yd-preview-item>
      <yd-preview-item v-for="i in oldBookNum" :key="i">
        <div slot="left" style="color: red">入住人（房间{{i}}）</div>
        <div slot="right">
          <div style="color: #333;" @click="addContacts(book.id, i)">{{HotelContacts[i] ? HotelContacts[i] : '添加'}}
          </div>
        </div>
      </yd-preview-item>
    </yd-preview>

    <yd-cell-group class="waibu_cell_box">
      <yd-cell-item>
        <span slot="left">联系人：</span>
        <yd-input slot="right" required v-model="order.contact" max="20" placeholder="请输入联系人"></yd-input>
      </yd-cell-item>
      <yd-cell-item>
        <span slot="left">手机号：</span>
        <yd-input slot="right" required v-model="order.mobile_phone" regex="mobile" placeholder="请输入手机号码"></yd-input>
      </yd-cell-item>
      <yd-cell-item @click.native="invoiceShow = true" v-if="system.hotel_is_open !== '0'">
        <span slot="left">发票：</span>
        <span slot="right">{{invoiceMsg}}<yd-icon name="more"></yd-icon></span>
      </yd-cell-item>
      <yd-cell-item>
        <span slot="left">留言：</span>
        <yd-input slot="right" v-model="order.message" :show-success-icon="false" :show-error-icon="false"
                  placeholder="特殊需求请留言"></yd-input>
      </yd-cell-item>
    </yd-cell-group>
    <yd-button size="large" type="primary" @click.native="submitOrder" v-preventReClick>提交订单</yd-button>
    <yd-popup v-model="invoiceShow" position="bottom" height="80%" style="color: black;" class="invoice">
      <div class="close_btn">
        <span @click="invoiceShow = false">
          <img src="~assets/image/white_close.png" alt="">
        </span>
      </div>
      <yd-flexbox>
        <yd-flexbox-item class="invoice_h1">发票</yd-flexbox-item>
      </yd-flexbox>
      <!-- <br> -->
      <div v-if="system.hotel_is_open === '1'">
        <h3>开发票</h3>
        <yd-switch v-model="iskai"></yd-switch>
        <!-- <br> -->
      </div>
      <div v-show="iskai">
        <p style="color: #666;margin: .2rem 0;">{{system.hotel_info}}</p>
        <h3>发票类型</h3>
        <yd-radio-group v-model="invoice.type" class="radio_box">
          <yd-radio v-for="(i,key) in system.hotel_invoicetype" :val="key" :key="key">{{i}}</yd-radio>
        </yd-radio-group>
        <!-- <br> -->
        <h3>发票抬头</h3>
        <yd-radio-group v-model="invoice.leixing" class="radio_box">
          <yd-radio v-if="(system.hotel_InvoiceLeixing === '3' || system.hotel_InvoiceLeixing === '1')" val="1">个人
          </yd-radio>
          <yd-radio v-if="(system.hotel_InvoiceLeixing === '3' || system.hotel_InvoiceLeixing === '2')" val="2">单位
          </yd-radio>
        </yd-radio-group>
        <div class="invoice_inf">
          <yd-cell-item>
            <span slot="left"><i style="color: red" v-show="invoiceNameRequire">*</i> 单位名称：</span>
            <input slot="right" type="text" v-model="invoice.name" class="input_height" placeholder="请输入单位名称">
          </yd-cell-item>
          <yd-cell-item>
            <span slot="left"><i style="color: red" v-show="invoiceShuinoRequire">*</i> 纳税人识别码：</span>
            <input slot="right" type="text" class="input_height" v-model="invoice.shuino" placeholder="请输入纳税人识别码">
          </yd-cell-item>
          <yd-cell-item>
            <span slot="left"><i style="color: red" v-show="invoiceZzaddressRequire">*</i> 单位地址：</span>
            <input slot="right" type="text" class="input_height" v-model="invoice.zzaddress" placeholder="请输入单位地址">
          </yd-cell-item>
          <yd-cell-item>
            <span slot="left"><i style="color: red" v-show="invoiceZzphoneRequire">*</i> 电话号码：</span>
            <input slot="right" type="text" class="input_height" v-model="invoice.zzphone" placeholder="请输入电话号码">
          </yd-cell-item>
          <yd-cell-item>
            <span slot="left"><i style="color: red" v-show="invoiceZzbankRequire">*</i> 开户银行：</span>
            <input slot="right" type="text" class="input_height" v-model="invoice.zzbank" placeholder="请输入开户银行">
          </yd-cell-item>
          <yd-cell-item>
            <span slot="left"><i style="color: red" v-show="invoiceZzaccountRequire">*</i> 银行账户：</span>
            <input slot="right" type="text" class="input_height" v-model="invoice.zzaccount" placeholder="请输入银行账户">
          </yd-cell-item>
          <yd-radio-group v-model="invoice.content" class="radio_box">
            <h3>开票内容</h3>
            <yd-radio v-for="(i,key) in system.hotel_invoice_content" :key="key" :val="key">{{i}}</yd-radio>
          </yd-radio-group>
          <yd-radio-group v-show="(system.hotel_separate === '1')" v-model="invoice.way" class="radio_box">
            <h3>分开开票</h3>
            <yd-radio val="1">开一张发票</yd-radio>
            <yd-radio val="2">分开开票</yd-radio>
          </yd-radio-group>
          <div v-if="system.hotel_invoicemail === '1'">
            <h3 slot="left">邮递</h3>
            <yd-switch v-model="invoice.needmail"></yd-switch>
          </div>
          <div
            v-show="invoiceLxrRequire || invoiceMobileRequire || invoiceEmailRequire || invoicePcdRequire || invoiceAddressRequire">
            <h3 style="margin-bottom: .14rem;">收票人信息</h3>
            <yd-cell-item v-show="invoiceLxrRequire">
              <span slot="left"><i style="color: red" v-show="invoiceLxrRequire">*</i> 收票人姓名：</span>
              <input slot="right" type="text" class="input_height" v-model="invoice.lxr" placeholder="请输入收票人姓名">
            </yd-cell-item>
            <yd-cell-item v-show="invoiceMobileRequire">
              <span slot="left"><i style="color: red" v-show="invoiceMobileRequire">*</i> 收票人手机：</span>
              <input slot="right" type="text" class="input_height" v-model="invoice.mobile" placeholder="请输入收票人手机">
            </yd-cell-item>
            <yd-cell-item v-show="invoiceEmailRequire">
              <span slot="left"><i style="color: red" v-show="invoiceEmailRequire">*</i> 收票人邮箱：</span>
              <input slot="right" type="text" class="input_height" v-model="invoice.email" placeholder="请输入收票人邮箱">
            </yd-cell-item>
            <yd-cell-item arrow v-show="invoicePcdRequire">
              <span slot="left"><i style="color: red" v-show="invoicePcdRequire">*</i> 所在地区：</span>
              <input slot="right" type="text" @click.stop="cityShow = true" class="input_height" v-model="pcd" readonly
                     placeholder="请选择省市县">
            </yd-cell-item>
            <yd-cityselect v-model="cityShow"
                           :callback="result1"
                           :provance="this.invoice.province"
                           :city="this.invoice.city"
                           :area="this.invoice.dist"
                           :items="district"
            ></yd-cityselect>
            <yd-cell-item v-show="invoiceAddressRequire">
              <span slot="left"><i style="color: red" v-show="invoiceAddressRequire">*</i> 详细地址：</span>
              <input slot="right" type="text" v-model="invoice.address" class="input_height" placeholder="请输入详细地址">
            </yd-cell-item>
          </div>
          <yd-button size="large" type="primary" @click.native="saveInvoice">确定</yd-button>
        </div>
      </div>
    </yd-popup>
    <yd-popup v-model="contactsShow" position="center" width="90%" class="">
      <div style="background-color:#fff;position: relative; padding-bottom: .55rem; border-radius: 5px;">
        <yd-checklist align="right" v-model="contactsCheckList" :callback="change" class="add_person">
          <yd-checklist-item v-for="(contacts,index) of contactsList" :key="index" :val="contacts.id"
                             :disabled="contactsDisabled[index]">
            <div style="height: 50px;line-height: 50px;">{{contacts.user_name}}</div>
          </yd-checklist-item>
        </yd-checklist>
        <p style="text-align: center;">
          <yd-button @click.native="contactsShow = false" class="qd_btn">确定</yd-button>
        </p>
      </div>
    </yd-popup>
  </div>
</template>

<script type="text/babel">
import axios from 'axios'
import {CitySelect} from 'vue-ydui/dist/lib.rem/cityselect'
import District from 'ydui-district/dist/gov_province_city_area_id'
import Vue from 'vue'

Vue.component(CitySelect.name, CitySelect)

export default {
  data () {
    return {
      cityShow: false,
      pcd: '',
      district: District,
      invoiceShow: false,
      invoiceMsg: '不开发票',
      invoiceNameRequire: true,
      invoiceShuinoRequire: true,
      invoiceZzaddressRequire: false,
      invoiceZzphoneRequire: false,
      invoiceZzbankRequire: false,
      invoiceZzaccountRequire: false,
      invoiceAddressRequire: false,
      invoicePcdRequire: false,
      invoiceEmailRequire: false,
      invoiceMobileRequire: false,
      invoiceLxrRequire: false,
      system: {},
      invoice: {
        'type': '',
        'content': 1,
        'way': 1,
        'leixing': '',
        'lxr': '',
        'mobile': '',
        'province': '',
        'city': '',
        'dist': '',
        'address': '',
        'name': '',
        'shuino': '',
        'zzaccount': '',
        'zzbank': '',
        'zzphone': '',
        'zzaddress': '',
        'email': '',
        'needmail': 0
      },
      iskai: 0,
      contactsShow: false,
      params: this.$route.params,
      book: [],
      HotelContacts: [],
      oldBookNum: 0,
      token: this.$store.state.token,
      contactsList: [],
      contactsDisabled: [],
      contactsCheckList: [],
      HotelContactsList: [],
      contactsIndex: 0,
      isCheckAll: false,
      order: {
        contact: localStorage.getItem('name'),
        mobile_phone: localStorage.getItem('mobile_phone')
      }
    }
  },
  methods: {
    HistoryBack () {
      window.history.back()
    },
    getRequestBook () {
      let dataf = {uid: this.$store.state.uid, fair_id: this.params.id, invoice: 1}
      let that = this
      axios.defaults.headers.post['Authorization'] = 'Bearer ' + this.$store.state.token
      axios
        .post('/hotel/request-book', dataf)
        .then((res) => {
          res = res.data
          if (res.status) {
            this.book = res.data[0]
            this.oldBookNum = parseInt(this.book.num) // 不是整数类型
            this.system = res.system
            if (this.system.hotel_is_open === '2') {
              this.iskai = 1
            }
            if (this.system.hotel_invoicemail === '2') {
              this.invoice.needmail = true
            }
          } else {
            this.$router.push({path: 'hotel-list'})
          }
        })
        .catch(function (res) {
          localStorage.clear()
          that.$dialog.toast({mes: '身份过期请重新登录'})
          window.location.reload()
        })
    },
    bookDel (id) {
      let that = this
      axios.defaults.headers.post['Authorization'] = 'Bearer ' + this.token
      axios
        .post('/hotel/del-book-hotel', {id: id, fair_id: this.params.id})
        .then((res) => {
          res = res.data
          if (res.status === 1) {
            this.$router.push({path: '/' + this.params.id + '/hotel-list/'})
          } else {
            this.$dialog.toast({
              mes: res.msg
            })
          }
        })
        .catch(function (res) {
          localStorage.clear()
          that.$dialog.toast({mes: '身份过期请重新登录'})
          window.location.reload()
        })
    },
    getContacts () {
      let that = this
      let data = {uid: this.$store.state.uid, fairid: this.params.id}
      axios.defaults.headers.post['Authorization'] = 'Bearer ' + this.token
      axios
        .post('/user/contacts', data)
        .then((res) => {
          res = res.data
          if (res.status) {
            this.contactsList = res.data
            this.updateContactsDisabled()
          }
        })
        .catch(function (res) {
          localStorage.clear()
          that.$dialog.toast({mes: '身份过期请重新登录'})
          window.location.reload()
        })
    },
    updateContactsDisabled () {
      this.contactsDisabled = []
      this.contactsList.forEach(contacts => {
        this.contactsDisabled.push(false)
      })
    },
    updateBook () {
      let differ = this.book.num - this.oldBookNum
      if (differ === 0) {
        return false
      }
      this.$dialog.loading.open()
      let that = this
      let data = {bookid: this.book.id, num: differ}
      axios.defaults.headers.post['Authorization'] = 'Bearer ' + this.token
      axios
        .post('/hotel/book-calculation', data)
        .then((res) => {
          this.$dialog.loading.close()
          res = res.data
          if (res.status) {
            this.book.price = res.data.price.toFixed(2)
            this.oldBookNum = this.book.num
            this.contactsCheckList = []
            this.HotelContactsList = []
            this.HotelContacts = []
          } else {
            this.book.num = this.oldBookNum
            this.$dialog.toast({
              mes: res.msg
            })
          }
        })
        .catch(function (res) {
          this.$dialog.loading.close()
          localStorage.clear()
          that.$dialog.toast({mes: '身份过期请重新登录'})
          window.location.reload()
        })
    },
    addContacts (bookid, index) {
      this.contactsIndex = index
      this.contactsCheckList = []
      this.contactsShow = true
    },
    change (value, isCheckAll) {
      let index = this.contactsIndex
      if (value.length >= this.book.max) {
        this.contactsDisabled = []

        this.contactsList.forEach(contacts => {
          if (value.indexOf(contacts.id) > -1) {
            this.contactsDisabled.push(false)
          } else {
            this.contactsDisabled.push(true)
          }
        })

        if (value.length > this.book.max) {
          this.$dialog.toast({
            mes: '房间' + index + '超出最大入住人数'
          })
          return false
        }
      } else {
        this.updateContactsDisabled()
      }
      this.HotelContactsList[index] = value
      let contactsNames = ''
      this.contactsList.forEach(contacts => {
        value.forEach(v => {
          if (v === contacts.id) {
            if (contactsNames !== '') {
              contactsNames = contactsNames + '、' + contacts.user_name
            } else {
              contactsNames = contactsNames + contacts.user_name
            }
          }
        })
      })
      this.HotelContacts[index] = contactsNames
      this.isCheckAll = isCheckAll
    },
    checkAll () {
      this.isCheckAll = !this.isCheckAll
      this.$refs.checklistDemo.$emit('ydui.checklist.checkall', this.isCheckAll)
    },
    submitOrder () {
      let invoiceRes = this.checkInvoice()
      if (!invoiceRes) {
        this.$dialog.toast({
          mes: '请检查发票信息是否正确'
        })
        return false
      }
      if (this.HotelContactsList.length <= 0) {
        this.$dialog.toast({
          mes: '请选择住宿人'
        })
        return false
      }
      let contactsData = []
      let cRes = true
      for (let i = 1; i <= this.book.num; i++) {
        if (this.HotelContactsList[i] === undefined || this.HotelContactsList[i].length <= 0) {
          this.$dialog.toast({
            mes: '房间' + (i) + '请选择住宿人'
          })
          cRes = false
          break
        }
        this.HotelContactsList[i].forEach(contact => {
          contactsData.push({fangjian_no: i, id: contact, roomid: this.book.exh_room_id, cart_id: this.book.id})
        })
      }
      if (cRes === false) {
        return false
      }
      let data = {
        order_fair_id: this.params.id,
        uid: this.$store.state.uid,
        linkman: this.order.contact,
        phone: this.order.mobile_phone,
        message: this.order.message,
        ExhRoomorderContacts: contactsData,
        iskai: this.iskai,
        ExhInvoice: {
          'type': this.invoice.type,
          'content': this.invoice.content,
          'way': this.invoice.way,
          'leixing': this.invoice.leixing,
          'lxr': this.invoice.lxr,
          'mobile': this.invoice.mobile,
          'province': this.invoice.province,
          'city': this.invoice.city,
          'dist': this.invoice.dist,
          'address': this.invoice.address,
          'name': this.invoice.name,
          'shuino': this.invoice.shuino,
          'zzaccount': this.invoice.zzaccount,
          'zzbank': this.invoice.zzbank,
          'zzphone': this.invoice.zzphone,
          'zzaddress': this.invoice.zzaddress,
          'email': this.invoice.email,
          'needmail': this.invoice.needmail
        }
      }
      let that = this
      axios.defaults.headers.post['Authorization'] = 'Bearer ' + this.token
      axios
        .post('/hotel/yuding', data)
        .then((res) => {
          res = res.data
          if (res.status === 1 && res.data.order_status !== 10) {
            this.$router.push({path: 'fair-pay/' + res.data.orderid})
          } else if (res.status === 1 && res.data.order_status === 10) {
            this.$router.push({path: 'single-my'})
          } else {
            this.$dialog.toast({
              mes: res.msg
            })
          }
        })
        .catch(function (res) {
          localStorage.clear()
          that.$dialog.toast({mes: '身份过期请重新登录'})
          window.location.reload()
        })
    },
    saveInvoice () {
      var type = ''
      if (this.invoice.type === '1') {
        type = '普票'
      }
      if (this.invoice.type === '2') {
        type = '电子发票'
      }
      if (this.invoice.type === '3') {
        type = '增值发票'
      }
      if (this.iskai) {
        this.invoiceMsg = type + '(' + this.invoice.name + ')'
      } else {
        this.invoiceMsg = '不开发票'
      }
      let invoiceRes = this.checkInvoice()
      if (invoiceRes) {
        this.invoiceShow = false
      }
    },
    checkInvoiceRequire () {
      this.invoiceEmailRequire = false
      if (this.invoice.type === '1') {
        this.invoiceNameRequire = true
        this.invoiceZzaddressRequire = false
        this.invoiceZzphoneRequire = false
        this.invoiceZzbankRequire = false
        this.invoiceZzaccountRequire = false
      } else if (this.invoice.type === '2') {
        this.invoiceNameRequire = true
        this.invoiceZzaddressRequire = false
        this.invoiceZzphoneRequire = false
        this.invoiceZzbankRequire = false
        this.invoiceZzaccountRequire = false
        this.invoiceEmailRequire = true
      } else if (this.invoice.type === '3') {
        this.invoiceNameRequire = true
        this.invoiceShuinoRequire = true
        this.invoiceZzaddressRequire = true
        this.invoiceZzphoneRequire = true
        this.invoiceZzbankRequire = true
        this.invoiceZzaccountRequire = true
      }
      if (this.invoice.leixing === '1' && this.invoice.type !== '3') {
        this.invoiceShuinoRequire = false
      } else {
        this.invoiceShuinoRequire = true
      }
      if (this.invoice.needmail === true) {
        this.invoiceLxrRequire = true
        this.invoicePcdRequire = true
        this.invoiceMobileRequire = true
        this.invoiceAddressRequire = true
      } else {
        this.invoiceLxrRequire = false
        this.invoicePcdRequire = false
        this.invoiceMobileRequire = false
        this.invoiceAddressRequire = false
      }
    },
    checkInvoice () {
      if (this.iskai) {
        if (this.invoice.type === '') {
          this.$dialog.toast({
            mes: '发票类型必填'
          })
          return false
        }
        if (this.invoice.leixing === '') {
          this.$dialog.toast({
            mes: '发票抬头类别必填'
          })
          return false
        }
        if (this.invoiceNameRequire) {
          if (this.invoice.name === '' || this.invoice.name.length <= 0) {
            this.$dialog.toast({
              mes: '发票名称必填'
            })
            return false
          }
        }
        if (this.invoiceShuinoRequire) {
          if (this.invoice.shuino === '' || this.invoice.shuino.length <= 0) {
            this.$dialog.toast({
              mes: '发票税号必填'
            })
            return false
          }
        }
        if (this.invoiceZzaddressRequire) {
          if (this.invoice.zzaddress === '' || this.invoice.zzaddress.length <= 0) {
            this.$dialog.toast({
              mes: '单位地址必填'
            })
            return false
          }
        }
        if (this.invoiceZzphoneRequire) {
          if (this.invoice.zzphone === '' || this.invoice.zzphone.length <= 0) {
            this.$dialog.toast({
              mes: '电话号码必填'
            })
            return false
          }
        }
        if (this.invoiceZzbankRequire) {
          if (this.invoice.zzbank === '' || this.invoice.zzbank.length <= 0) {
            this.$dialog.toast({
              mes: '开户银行必填'
            })
            return false
          }
        }
        if (this.invoiceZzaccountRequire) {
          if (this.invoice.zzaccount === '' || this.invoice.zzaccount.length <= 0) {
            this.$dialog.toast({
              mes: '银行账户必填'
            })
            return false
          }
        }
        if (this.invoiceLxrRequire) {
          if (this.invoice.lxr === '' || this.invoice.lxr.length <= 0) {
            this.$dialog.toast({
              mes: '收件人姓名必填'
            })
            return false
          }
        }
        if (this.invoiceMobileRequire) {
          if (this.invoice.mobile === '' || this.invoice.mobile.length <= 0) {
            this.$dialog.toast({
              mes: '收件人手机号必填'
            })
            return false
          }
        }
        if (this.invoiceEmailRequire) {
          if (this.invoice.email === '' || this.invoice.email.length <= 0) {
            this.$dialog.toast({
              mes: '收件人邮箱必填'
            })
            return false
          }
        }
        if (this.invoicePcdRequire) {
          if (this.invoice.province === '' || this.invoice.province.length <= 0 || this.invoice.city === '' || this.invoice.city.length <= 0 || this.invoice.dist === '' || this.invoice.dist.length <= 0) {
            this.$dialog.toast({
              mes: '收件人省市县必填'
            })
            return false
          }
        }
        if (this.invoiceAddressRequire) {
          if (this.invoice.address === '' || this.invoice.address.length <= 0) {
            this.$dialog.toast({
              mes: '收件人详细地址必填'
            })
            return false
          }
        }
      }
      return true
    },
    result1 (ret) {
      this.pcd = ret.itemName1 + ' ' + ret.itemName2 + ' ' + ret.itemName3
      this.invoice.province = ret.itemValue1
      this.invoice.city = ret.itemValue2
      this.invoice.dist = ret.itemValue3
    },
    checkLogin () {
      if (!this.$store.state.uid) {
        this.$router.push({path: '/' + this.params.id + '/single-my'})
      }
    }
  },
  mounted () {
    this.checkLogin()
    this.getRequestBook()
    this.getContacts()
  },
  watch: {
    'invoice.type': function () {
      this.checkInvoiceRequire()
    },
    'invoice.leixing': function () {
      this.checkInvoiceRequire()
    },
    'invoice.needmail': function () {
      this.checkInvoiceRequire()
    },
    'iskai': function () {
      this.invoice.leixing = 1
      if (this.system.hotel_InvoiceLeixing === '2') {
        this.invoice.leixing = 2
      }
      for (let key in this.system.hotel_invoicetype) {
        this.invoice.type = key
        break
      }
      for (let key in this.system.hotel_invoice_content) {
        this.invoice.content = key
        break
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
  .room_buy
    // position: absolute
    background-color: #FFFFFF
    // padding: 0 .2rem
    padding-top: .2rem
    width: 100%
    height: 100%

  .room_buy .yd-preview-header
    margin-left: .4rem
    padding-right: .4rem
    height: .8rem

  .room_buy .yd-preview-item
    padding: .2rem .4rem
    padding-top: 0
    height: .8rem

  .room_buy .yd-preview-header > :last-child
    font-size: .28rem

  .room_buy .yd-spinner
    text-align-last: center

  .room_buy .yd-preview::after
    display: block
    content: ""
    width: 100% !important
    height: 1px
    color: #333

  .room_buy .add_mount
    // padding-bottom: .4rem
    margin-bottom: .2rem

  .room_buy .waibu_cell_box .yd-cell-item
    padding: 0 .4rem
    padding-right: 0

  .room_buy .waibu_cell_box .yd-cell::after
    display: none

  .room_buy .waibu_cell_box .yd-cell-item::after
    // width: calc(100% - .8rem)!important
    // margin-left: .4rem!important
    display: none

  .room_buy .waibu_cell_box .yd-cell-left
    color: #333
    padding: 0

  .room_buy .waibu_cell_box .yd-cell .yd-cell-right
    height: 1rem
    padding: 0

  .room_buy .yd-icon-more
    font-size: .32rem !important
    margin-left: .08rem

  .room_buy .waibu_cell_box
    border-top: solid 1px #f0f0f0
    padding-right: .16rem

  .room_buy .close_btn
    color: #fff
    width: 0
    height: 0
    border: solid .45rem
    border-color: orangered orangered transparent transparent
    border-top-right-radius: .2rem
    position: absolute
    top: 0
    right: 0

  .room_buy .close_btn span
    font-size: .24rem
    position: absolute
    top: -0.3rem
    right: -0.3rem

  .room_buy .invoice_h1
    font-size .4rem

  .room_buy .invoice h3
    color: black
    font-size: .32rem

  .room_buy .add_popup
    height 100%

  .room_buy .add_popup > :last-child > :first-child
    height 100%

  .room_buy .add_popup > :last-child > :first-child > :first-child
    height 100%

  .room_buy .qd_btn
    padding 0 .4rem

  .room_buy .add_person
    margin-bottom 0.55rem
    border-radius 5px
    

  .yd-radio
    display block
    float left
    margin-bottom .26rem
    
  .radio_box
    overflow hidden

  .add_popup
    display none

  .g-fix-ios-prevent-scroll .add_popup
    display block
</style>



// WEBPACK FOOTER //
// src/views/template1/RoomBuy.vue